export default () => ({
  activeStickySearchBar: false,
  config: {
    debug: false, // ver parametros que envia
    mock: [''],
    isModal: false
  },
  sticky: [],
  queryParams: {}, // brute params
  querySearch: null, // refined params
  searchTerm: '',
  searchResults: null,
  searchFilter: {},
  searchSelected: {
    autocomplete: {},
    dates: null,
    occupancy: null,
    voucherCode: null,
    gvoucher: null,
    nearme: false,
    nearmeLocation: {}
  },
  hotel: null,
  errors: {},
  instances: {},
  module: null,
  optionsCalendar: {
    maxNights: null,
    minNights: 0,
    firstDayOfWeek: 1
  },
  paths: {
    rd: '/booking/step1-rates'
  },
  externalRedirect: null,
  b2bParams: [
    'eventTool',
    'regimen',
    'ratePriceCode',
    'evId',
    'urlEvent',
    'contactPhone',
    'b2b',
    'b2bData.branch',
    'b2bData.branchId',
    'b2bData.company',
    'b2bData.customer',
    'b2bData.partyIdCompany',
    'b2bData.partyIdCustomer',
    'b2bData.type',
    'b2bData.bpc',
    'b2bData.subsidiary',
    'b2bData.favouriteHotels',
    'b2bData.frequentHotels',
    'b2bData.travelAgentRate',
    'b2bData.isCcgType',
    'b2bData.ccgType'
  ]
})
